/** Retorna o objeto matrixPayload se existir (campo salvo, legado em options). */
export function getMatrixPayload(question) {
  if (!question) return null;
  const mp = question.matrixPayload ?? question.matrixAnswer;
  if (mp && typeof mp === 'object' && mp.matrix === true && Array.isArray(mp.rows)) {
    return mp;
  }
  const opts = normalizeQuestionOptions(question.options);
  for (const o of opts) {
    if (o && typeof o === 'object' && o.matrix === true && Array.isArray(o.rows)) {
      return o;
    }
  }
  return null;
}

/**
 * Cabeçalho de coluna CSV para uma linha da matriz (pergunta principal + rótulo da linha).
 */
export function buildMatrixCsvColumnKey(questionText, rowLabel) {
  const q = (questionText || 'Pergunta').replace(/\r?\n/g, ' ').replace(/\s+/g, ' ').trim();
  const r = String(rowLabel ?? '').trim() || '(item)';
  return `${q} — ${r}`;
}

/**
 * Formata o payload salvo de pergunta tipo matriz ({ matrix, rows }) em texto para CSV/UI.
 */
export function matrixPayloadToPlainText(payload) {
  if (!payload || payload.matrix !== true || !Array.isArray(payload.rows)) return '';
  return payload.rows
    .map((r) => {
      const label = r.rowLabel != null ? String(r.rowLabel).trim() : '';
      const col = r.columnLabel != null ? String(r.columnLabel).trim() : '';
      if (!label && !col) return '';
      return col ? `${label}: ${col}` : label;
    })
    .filter(Boolean)
    .join(' | ');
}

export function normalizeQuestionOptions(options) {
  if (options == null) return [];
  if (Array.isArray(options)) return options;
  if (typeof options === 'object' && options.matrix === true && Array.isArray(options.rows)) {
    return [options];
  }
  return [options];
}

/** Texto para uma entrada em question.options (legado: objeto matriz; novo: string) */
export function formatOptionEntryForCsv(o) {
  if (o == null || o === '') return '';
  if (typeof o === 'object') {
    if (o.matrix === true && Array.isArray(o.rows)) {
      return matrixPayloadToPlainText(o);
    }
    try {
      return JSON.stringify(o);
    } catch {
      return String(o);
    }
  }
  return String(o);
}

/**
 * Texto final da resposta a uma pergunta (matriz nova, legado ou outro tipo).
 */
export function getQuestionAnswerPlainText(question) {
  if (!question) return '';
  const mp = getMatrixPayload(question);
  if (mp) {
    return matrixPayloadToPlainText(mp);
  }
  if (question.questionType === 'checkbox' && Array.isArray(question.options)) {
    return question.options
      .map((o) => (o == null ? '' : String(o).trim()))
      .filter(Boolean)
      .join(', ');
  }
  const opts = normalizeQuestionOptions(question.options);
  if (opts.length === 1 && typeof opts[0] === 'string') {
    return opts[0];
  }
  return opts.map(formatOptionEntryForCsv).filter(Boolean).join(' | ');
}
